<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/aizhaiIndex">首页</el-menu-item>
        <el-menu-item index="/aizhai/currentHumidityList?bridgeId=a89de080-e7dd-4c08-9298-0e3357cb9e4c&sortByItemCount=1">湿度数据清单</el-menu-item>
        <el-menu-item index="/aizhai/currentDataTable?bridgeId=a89de080-e7dd-4c08-9298-0e3357cb9e4c">实时数据表</el-menu-item>
        <el-submenu :index="'/aizhai/dataHistory?bridgeId=a89de080-e7dd-4c08-9298-0e3357cb9e4c&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/aizhai/dataHistory?bridgeId=a89de080-e7dd-4c08-9298-0e3357cb9e4c&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/aizhai/dataHistory?bridgeId=a89de080-e7dd-4c08-9298-0e3357cb9e4c"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="HUNAN" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main ai-zhai">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "aizhai",
  data() {
    return {
      bridgeId: "a89de080-e7dd-4c08-9298-0e3357cb9e4c",
      envInfo: {
        envId: "c71411cb-d7f4-4e1c-a4be-b947484ea882",
        weather: "fcb0aa92-39b7-4f61-a8a5-6825023ea6b1",
        humidity: "ee587957-abbc-46fb-9807-eb1b964a5f0b",
        temperature: "80adad04-2c9d-4bdf-91bb-9f79c9f350a2",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>